<template>
    <a
        class="cursor-pointer"
        :href="href"
        @click.prevent="smoothScroll">
        <slot></slot>
    </a>
</template>

<script>
export default {
  props: ['href'],
  methods: {
    smoothScroll() {
      document.querySelector(this.href).scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>

</style>
